// extracted by mini-css-extract-plugin
export var avatar = "_pk-3";
export var avatarContainer = "_pk-2";
export var avatarSpacer = "_pk-5";
export var avatarSpacerContainer = "_pk-4";
export var avatarStackContainer = "_pk-1";
export var bubble = "_pk-0";
export var remainderBubble = "_pk-6";